/* src/components/Toolbar/components/Shapes.svelte generated by Svelte v3.54.0 */
import {
	SvelteComponent,
	action_destroyer,
	append,
	attr,
	check_outros,
	construct_svelte_component,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	is_function,
	listen,
	mount_component,
	noop,
	outro_and_destroy_block,
	safe_not_equal,
	space,
	subscribe,
	toggle_class,
	transition_in,
	transition_out,
	update_keyed_each
} from "svelte/internal";

import { tippy } from "../../../actions/tippy";

import {
	shapes,
	shapesIcon,
	shapesIconActive,
	applianceShapes
} from "./constants";

import { tooltip } from "./helper";

function get_each_context(ctx, list, i) {
	const child_ctx = ctx.slice();
	child_ctx[12] = list[i];

	const constants_0 = /*appliance*/ child_ctx[4] === "shape"
	? /*shape*/ child_ctx[3] === /*key*/ child_ctx[12]
	: /*appliance*/ child_ctx[4] === /*key*/ child_ctx[12];

	child_ctx[13] = constants_0;
	return child_ctx;
}

// (78:6) {:else}
function create_else_block(ctx) {
	let switch_instance;
	let switch_instance_anchor;
	let current;
	var switch_value = shapesIcon[/*key*/ ctx[12]];

	function switch_props(ctx) {
		return { props: { theme: /*theme*/ ctx[0] } };
	}

	if (switch_value) {
		switch_instance = construct_svelte_component(switch_value, switch_props(ctx));
	}

	return {
		c() {
			if (switch_instance) create_component(switch_instance.$$.fragment);
			switch_instance_anchor = empty();
		},
		m(target, anchor) {
			if (switch_instance) mount_component(switch_instance, target, anchor);
			insert(target, switch_instance_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const switch_instance_changes = {};
			if (dirty & /*theme*/ 1) switch_instance_changes.theme = /*theme*/ ctx[0];

			if (switch_value !== (switch_value = shapesIcon[/*key*/ ctx[12]])) {
				if (switch_instance) {
					group_outros();
					const old_component = switch_instance;

					transition_out(old_component.$$.fragment, 1, 0, () => {
						destroy_component(old_component, 1);
					});

					check_outros();
				}

				if (switch_value) {
					switch_instance = construct_svelte_component(switch_value, switch_props(ctx));
					create_component(switch_instance.$$.fragment);
					transition_in(switch_instance.$$.fragment, 1);
					mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
				} else {
					switch_instance = null;
				}
			} else if (switch_value) {
				switch_instance.$set(switch_instance_changes);
			}
		},
		i(local) {
			if (current) return;
			if (switch_instance) transition_in(switch_instance.$$.fragment, local);
			current = true;
		},
		o(local) {
			if (switch_instance) transition_out(switch_instance.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(switch_instance_anchor);
			if (switch_instance) destroy_component(switch_instance, detaching);
		}
	};
}

// (76:6) {#if is_selected}
function create_if_block(ctx) {
	let switch_instance;
	let switch_instance_anchor;
	let current;
	var switch_value = shapesIconActive[/*key*/ ctx[12]];

	function switch_props(ctx) {
		return {
			props: { theme: /*theme*/ ctx[0], active: true }
		};
	}

	if (switch_value) {
		switch_instance = construct_svelte_component(switch_value, switch_props(ctx));
	}

	return {
		c() {
			if (switch_instance) create_component(switch_instance.$$.fragment);
			switch_instance_anchor = empty();
		},
		m(target, anchor) {
			if (switch_instance) mount_component(switch_instance, target, anchor);
			insert(target, switch_instance_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const switch_instance_changes = {};
			if (dirty & /*theme*/ 1) switch_instance_changes.theme = /*theme*/ ctx[0];

			if (switch_value !== (switch_value = shapesIconActive[/*key*/ ctx[12]])) {
				if (switch_instance) {
					group_outros();
					const old_component = switch_instance;

					transition_out(old_component.$$.fragment, 1, 0, () => {
						destroy_component(old_component, 1);
					});

					check_outros();
				}

				if (switch_value) {
					switch_instance = construct_svelte_component(switch_value, switch_props(ctx));
					create_component(switch_instance.$$.fragment);
					transition_in(switch_instance.$$.fragment, 1);
					mount_component(switch_instance, switch_instance_anchor.parentNode, switch_instance_anchor);
				} else {
					switch_instance = null;
				}
			} else if (switch_value) {
				switch_instance.$set(switch_instance_changes);
			}
		},
		i(local) {
			if (current) return;
			if (switch_instance) transition_in(switch_instance.$$.fragment, local);
			current = true;
		},
		o(local) {
			if (switch_instance) transition_out(switch_instance.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(switch_instance_anchor);
			if (switch_instance) destroy_component(switch_instance, detaching);
		}
	};
}

// (67:2) {#each shapes as key (key)}
function create_each_block(key_1, ctx) {
	let button;
	let current_block_type_index;
	let if_block;
	let t_1;
	let button_class_value;
	let button_data_shape_key_value;
	let tippy_action;
	let current;
	let mounted;
	let dispose;
	const if_block_creators = [create_if_block, create_else_block];
	const if_blocks = [];

	function select_block_type(ctx, dirty) {
		if (/*is_selected*/ ctx[13]) return 0;
		return 1;
	}

	current_block_type_index = select_block_type(ctx, -1);
	if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);

	return {
		key: key_1,
		first: null,
		c() {
			button = element("button");
			if_block.c();
			t_1 = space();
			attr(button, "class", button_class_value = "fastboard-toolbar-btn fastboard-toolbar-shape-btn " + /*theme*/ ctx[0] + " " + /*key*/ ctx[12]);
			attr(button, "data-shape-key", button_data_shape_key_value = /*key*/ ctx[12]);
			button.disabled = /*disabled*/ ctx[1];
			toggle_class(button, "is-active", /*is_selected*/ ctx[13]);
			this.first = button;
		},
		m(target, anchor) {
			insert(target, button, anchor);
			if_blocks[current_block_type_index].m(button, null);
			append(button, t_1);
			current = true;

			if (!mounted) {
				dispose = action_destroyer(tippy_action = tippy.call(null, button, {
					content: tooltip(/*t*/ ctx[6][/*key*/ ctx[12]], /*c*/ ctx[2][/*key*/ ctx[12]]),
					placement: "top"
				}));

				mounted = true;
			}
		},
		p(new_ctx, dirty) {
			ctx = new_ctx;
			let previous_block_index = current_block_type_index;
			current_block_type_index = select_block_type(ctx, dirty);

			if (current_block_type_index === previous_block_index) {
				if_blocks[current_block_type_index].p(ctx, dirty);
			} else {
				group_outros();

				transition_out(if_blocks[previous_block_index], 1, 1, () => {
					if_blocks[previous_block_index] = null;
				});

				check_outros();
				if_block = if_blocks[current_block_type_index];

				if (!if_block) {
					if_block = if_blocks[current_block_type_index] = if_block_creators[current_block_type_index](ctx);
					if_block.c();
				} else {
					if_block.p(ctx, dirty);
				}

				transition_in(if_block, 1);
				if_block.m(button, t_1);
			}

			if (!current || dirty & /*theme*/ 1 && button_class_value !== (button_class_value = "fastboard-toolbar-btn fastboard-toolbar-shape-btn " + /*theme*/ ctx[0] + " " + /*key*/ ctx[12])) {
				attr(button, "class", button_class_value);
			}

			if (!current || dirty & /*disabled*/ 2) {
				button.disabled = /*disabled*/ ctx[1];
			}

			if (tippy_action && is_function(tippy_action.update) && dirty & /*t, c*/ 68) tippy_action.update.call(null, {
				content: tooltip(/*t*/ ctx[6][/*key*/ ctx[12]], /*c*/ ctx[2][/*key*/ ctx[12]]),
				placement: "top"
			});

			if (!current || dirty & /*theme, appliance, shape, shapes*/ 25) {
				toggle_class(button, "is-active", /*is_selected*/ ctx[13]);
			}
		},
		i(local) {
			if (current) return;
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(button);
			if_blocks[current_block_type_index].d();
			mounted = false;
			dispose();
		}
	};
}

function create_fragment(ctx) {
	let div;
	let each_blocks = [];
	let each_1_lookup = new Map();
	let div_class_value;
	let current;
	let mounted;
	let dispose;
	let each_value = shapes;
	const get_key = ctx => /*key*/ ctx[12];

	for (let i = 0; i < each_value.length; i += 1) {
		let child_ctx = get_each_context(ctx, each_value, i);
		let key = get_key(child_ctx);
		each_1_lookup.set(key, each_blocks[i] = create_each_block(key, child_ctx));
	}

	return {
		c() {
			div = element("div");

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].c();
			}

			attr(div, "class", div_class_value = "fastboard-toolbar-shapes " + /*theme*/ ctx[0]);
		},
		m(target, anchor) {
			insert(target, div, anchor);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].m(div, null);
			}

			current = true;

			if (!mounted) {
				dispose = listen(div, "click", /*set_appliance_or_shape*/ ctx[7]);
				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*theme, shapes, disabled, tooltip, t, c, appliance, shape, shapesIconActive, shapesIcon*/ 95) {
				each_value = shapes;
				group_outros();
				each_blocks = update_keyed_each(each_blocks, dirty, get_key, 1, ctx, each_value, each_1_lookup, div, outro_and_destroy_block, create_each_block, null, get_each_context);
				check_outros();
			}

			if (!current || dirty & /*theme*/ 1 && div_class_value !== (div_class_value = "fastboard-toolbar-shapes " + /*theme*/ ctx[0])) {
				attr(div, "class", div_class_value);
			}
		},
		i(local) {
			if (current) return;

			for (let i = 0; i < each_value.length; i += 1) {
				transition_in(each_blocks[i]);
			}

			current = true;
		},
		o(local) {
			for (let i = 0; i < each_blocks.length; i += 1) {
				transition_out(each_blocks[i]);
			}

			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);

			for (let i = 0; i < each_blocks.length; i += 1) {
				each_blocks[i].d();
			}

			mounted = false;
			dispose();
		}
	};
}

const i18n = {
	en: {
		rectangle: "Rectangle",
		ellipse: "Ellipse",
		straight: "Line",
		arrow: "Arrow",
		pentagram: "Star",
		rhombus: "Diamond",
		triangle: "Triangle",
		speechBalloon: "Balloon"
	},
	"zh-CN": {
		rectangle: "\u77E9\u5F62",
		ellipse: "\u692D\u5706",
		straight: "\u76F4\u7EBF",
		arrow: "\u7BAD\u5934",
		pentagram: "\u4E94\u89D2\u661F",
		rhombus: "\u83F1\u5F62",
		triangle: "\u4E09\u89D2\u5F62",
		speechBalloon: "\u6C14\u6CE1"
	}
};

function instance($$self, $$props, $$invalidate) {
	let t;
	let memberState;
	let appliance;
	let shape;
	let hotkeys;

	let $memberState,
		$$unsubscribe_memberState = noop,
		$$subscribe_memberState = () => ($$unsubscribe_memberState(), $$unsubscribe_memberState = subscribe(memberState, $$value => $$invalidate(11, $memberState = $$value)), memberState);

	$$self.$$.on_destroy.push(() => $$unsubscribe_memberState());
	let { app = null } = $$props;
	let { theme = "light" } = $$props;
	let { language = "en" } = $$props;
	let { disabled = false } = $$props;
	let c;

	function set_appliance_or_shape(ev) {
		let button = ev.target;

		if (button && button.dataset.shapeKey) {
			let shape2 = button.dataset.shapeKey;

			if (shape2 && app) {
				if (applianceShapes.includes(shape2)) {
					app.setAppliance(shape2);
				} else {
					app.setAppliance("shape", shape2);
				}
			}
		}
	}

	$$self.$$set = $$props => {
		if ('app' in $$props) $$invalidate(8, app = $$props.app);
		if ('theme' in $$props) $$invalidate(0, theme = $$props.theme);
		if ('language' in $$props) $$invalidate(9, language = $$props.language);
		if ('disabled' in $$props) $$invalidate(1, disabled = $$props.disabled);
	};

	$$self.$$.update = () => {
		if ($$self.$$.dirty & /*language*/ 512) {
			$: $$invalidate(6, t = i18n[language]);
		}

		if ($$self.$$.dirty & /*app*/ 256) {
			$: $$subscribe_memberState($$invalidate(5, memberState = app?.memberState));
		}

		if ($$self.$$.dirty & /*$memberState*/ 2048) {
			$: $$invalidate(4, appliance = $memberState?.currentApplianceName);
		}

		if ($$self.$$.dirty & /*$memberState*/ 2048) {
			$: $$invalidate(3, shape = $memberState?.shapeType);
		}

		if ($$self.$$.dirty & /*app*/ 256) {
			$: $$invalidate(10, hotkeys = app?.hotKeys);
		}

		if ($$self.$$.dirty & /*hotkeys*/ 1024) {
			$: $$invalidate(2, c = {
				rectangle: hotkeys?.changeToRectangle,
				ellipse: hotkeys?.changeToEllipse,
				straight: hotkeys?.changeToStraight,
				arrow: hotkeys?.changeToArrow
			});
		}
	};

	return [
		theme,
		disabled,
		c,
		shape,
		appliance,
		memberState,
		t,
		set_appliance_or_shape,
		app,
		language,
		hotkeys,
		$memberState
	];
}

class Shapes extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			app: 8,
			theme: 0,
			language: 9,
			disabled: 1
		});
	}
}

export default Shapes;